import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TCatCoreModule } from '../core/core.module';
import { AddUserListComponent } from './comp/add-user-list/add-user-list.component';
import { AirlineInfoComponent } from './comp/airline-info/airline-info.component';
import { AirlineLogoStackComponent } from './comp/airline-logo-stack/airline-logo-stack.component';
import { AppContainerComponent } from './comp/app-container/app-container.component';
import { BroadcastMessagePopupComponent } from './comp/broadcast-message-popup/broadcast-message-popup.component';
import { FlightBaggagePolicyComponent } from './comp/flight-baggage-policy/flight-baggage-policy.component';
import { FlightChangePolicyComponent } from './comp/flight-change-policy/flight-change-policy.component';
import { FlightFarePolicyComponent } from './comp/flight-fare-policy/flight-fare-policy.component';
import { FlightLegDetailComponent } from './comp/flight-leg-detail/flight-leg-detail.component';
import { FlightPolicyIndicatorsDescriptiveComponent } from './comp/flight-policy-indicators-descriptive/flight-policy-indicators-descriptive.component';
import { FlightChangePolicyPopoverComponent } from './comp/flight-change-policy-popover/flight-change-policy-popover.component';

import { FlightPolicyIndicatorsComponent } from './comp/flight-policy-indicators/flight-policy-indicators.component';
import { HeaderComponent } from './comp/header/header.component';
import { IntlFlightLegDetailComponent } from './comp/intl-flight-leg-detail/intl-flight-leg-detail.component';
import { ListingViewComponent } from './comp/listing-view/listing-view.component';
import { MenuListItemComponent } from './comp/menu-list/menu-list-item/menu-list-item.component';
import { MenuListComponent } from './comp/menu-list/menu-list.component';
import { MessageHeaderComponent } from './comp/message-header/message-header.component';
import { RailDailyScheduleComponent } from './comp/rail/rail-daily-schedule/rail-daily-schedule.component';
import { TrainPreferenceSearchPopupComponent } from './comp/rail/train-preference-search-popup/train-preference-search-popup.component';
import { TrainStationsListComponent } from './comp/rail/train-preference-search-popup/train-stations-list/train-stations-list.component';
import { SideMenuComponent } from './comp/side-menu/side-menu.component';
import { FlightDurationPipe } from './flights/flight-duration.pipe';
import { FlightTimeToDatePipe } from './flights/flight-time-to-date.pipe';
import { CabRequestTypePipe } from './pipes/cabs/cab-request-type.pipe';
import { CabTripTypePipe } from './pipes/cabs/cab-trip-type.pipe';
import { CabTypePipe } from './pipes/cabs/cab-type.pipe';
import { AirlineLogoPipe } from './pipes/flights/airline-logo.pipe';
import { CabinClassPipe } from './pipes/flights/cabin-class.pipe';
import { GstStatePipe } from './pipes/gst/gst-state.pipe';
import { StarRatingPipe } from './pipes/hotel/star-rating.pipe';
import { SalutationPipe } from './pipes/salutation.pipe';
import { CommonFieldtypesService } from './services/field-types/common-fieldtypes.service';
import { SelectPrimaryTravellerComponent } from './comp/select-primary-traveller/select-primary-traveller.component';


@NgModule({
  declarations: [
    AppContainerComponent,
    HeaderComponent,
    MessageHeaderComponent,
    SideMenuComponent,
    ListingViewComponent,
    MenuListComponent,
    MenuListItemComponent,
    AirlineLogoPipe,
    BroadcastMessagePopupComponent,
    SalutationPipe,
    GstStatePipe,
    RailDailyScheduleComponent,
    CabRequestTypePipe,
    CabTypePipe,
    CabTripTypePipe,
    TrainPreferenceSearchPopupComponent,
    TrainStationsListComponent,
    AirlineInfoComponent,
    AirlineLogoStackComponent,
    IntlFlightLegDetailComponent,
    FlightLegDetailComponent,
    FlightBaggagePolicyComponent,
    FlightChangePolicyComponent,
    FlightFarePolicyComponent,
    CabinClassPipe,
    FlightPolicyIndicatorsComponent,
    FlightPolicyIndicatorsDescriptiveComponent,
    FlightChangePolicyPopoverComponent,
    AddUserListComponent,
    StarRatingPipe,
    FlightDurationPipe,
    FlightTimeToDatePipe,
    SelectPrimaryTravellerComponent
  ],
  imports: [
    CommonModule,
    TCatCoreModule,
  ],
  exports: [
    TCatCoreModule,
    AppContainerComponent,
    HeaderComponent,
    ListingViewComponent,
    MenuListComponent,
    MenuListItemComponent,
    RailDailyScheduleComponent,
    AirlineLogoPipe,
    SalutationPipe,
    GstStatePipe,
    CabRequestTypePipe,
    CabTypePipe,
    CabTripTypePipe,
    AirlineInfoComponent,
    AirlineLogoStackComponent,
    IntlFlightLegDetailComponent,
    FlightLegDetailComponent,
    FlightBaggagePolicyComponent,
    FlightChangePolicyComponent,
    FlightFarePolicyComponent,
    CabinClassPipe,
    FlightPolicyIndicatorsComponent,
    FlightPolicyIndicatorsDescriptiveComponent,
    FlightChangePolicyPopoverComponent,
    AddUserListComponent,
    StarRatingPipe,
    FlightTimeToDatePipe,
    FlightDurationPipe,
    SelectPrimaryTravellerComponent
  ]
})
export class TCatCommonModule { 

  constructor(private commonFieldTypes: CommonFieldtypesService) {
    commonFieldTypes.initializeFieldTypes();
  }
}
